import React from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";

const CreateNoteModal = ({ t, showModal, loading, setNote, handleModalClose, handleOk ,disabled}) => (
    <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("jobsManagement.infoJob.createNote")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleModalClose}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="text-primary mb-2" >{t("jobsManagement.infoJob.createNoteText")}</p>
                            <textarea onChange={e => setNote(e.target.value)} className="w-100 p-2" rows="4" placeholder={t("jobsManagement.infoJob.createNoteTextPlaceholder")} />
                        </div>
                        <div className="modal-footer">
                            <button type="button" disabled={disabled} className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={handleOk}>
                            {t("jobsManagement.infoJob.createNotebtn")} {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
);

export default CreateNoteModal;